import { useState } from 'react';
import { TariheGit } from './TariheGit';

const TarihGosterimi = ({ currentDate, onScrollPositionChange, interval }) => {
  const [showTariheGit, setShowTariheGit] = useState(false);
  const text_to_show = currentDate.toString()
  if (text_to_show=="error")
  {
    sessionStorage.setItem('timelineScrollPosition', 0)
    onScrollPositionChange(0)
  }
  const onScrollPositionChangeWrapper = (scrollposition) =>{
    onScrollPositionChange(scrollposition)
  }
  
  return (
    <div className="relative">
      <button
        onClick={() => setShowTariheGit(!showTariheGit)}
        className="flex items-center justify-center space-x-2 
          
          px-3 text-gray-700 hover:bg-gray-300 rounded
           py-1.5  
          hover:from-gray-200 hover:to-gray-300 
          transition-all duration-200"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
        <span>{currentDate.toString()}</span>
      </button>

      {showTariheGit && (
        <div className="absolute left-[-100px] mt-3 z-[9999] bg-slate-200 rounded p-1">
          <TariheGit onScrollPositionChange={onScrollPositionChangeWrapper} interval={interval} />
        </div>
      )}
    </div>
  );
};

export default TarihGosterimi; 